import './identity.style.sass';
import template from './identity.tpl.pug';

export default {
    selector: 'dbAIdentity',
    template: template()
};



// WEBPACK FOOTER //
// ./src/application/scene/identity/identity.cmpt.js